export default __webpack_public_path__ + "static/media/snowflake.99d98f02.png";